<template>
  <div :class="{ tab: true, active }" @click="tabClicked">
    {{ label }}
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    context: {
      required: true,
    },
  },
  computed: {
    active: function() {
      return this.id === this.context.activeTabId;
    },
  },
  methods: {
    tabClicked: function() {
      this.$emit("click", this.id);
    },
  },
  emits: ["click"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.tab {
  position: relative;
  top: 1px;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 8px;
  background-color: inherit;
  font-size: 12px;
  line-height: 12px;
  font-weight: bold;
  border-bottom: 1px solid $gray-500;

  &:hover {
    background-color: $gray-400;
  }

  &.active {
    background-color: $body-bg-colour;
    border-top: 1px solid $gray-500;
    border-left: 1px solid $gray-500;
    border-right: 1px solid $gray-500;
    border-bottom: 1px solid $body-bg-colour;
    border-radius: $border-radius $border-radius 0px 0px;
  }
}
</style>
